import { MenuItem } from 'src/components/navigation/src/types';

export const isMenuItemSelected = (
  menuItem: Pick<MenuItem, 'matching_url_prefixes' | 'url'>,
  pathname: string
) => {
  const matchesPathname = (prefix: string) => pathname.startsWith(prefix);
  return (
    menuItem.matching_url_prefixes.some(matchesPathname) ||
    // ignore optional trailing slash
    pathname?.replace(/\/$/, '').endsWith(menuItem.url?.replace(/\/$/, ''))
  );
};
